import { FC } from 'react';
import { Alert, Button } from '@mui/material';
import { CommonProfileConfirmationBannerProps } from './CommonProfileConfirmationBanner.props';

const CommonProfileConfirmationBanner: FC<CommonProfileConfirmationBannerProps> = ({
  isStaff,
  onEditProfile,
}) => {
  if (isStaff) {
    return (
      <Alert
        severity="warning"
        action={
          <Button color="inherit" size="small" onClick={onEditProfile}>
            Edit Common Profile
          </Button>
        }
      >
        This company's common profile match is pending confirmation. Review and confirm it in the
        Edit Common Profile dialog.
      </Alert>
    );
  }

  return (
    <Alert severity="info">
      No confirmed common profile has been set for this company yet.
    </Alert>
  );
};

export default CommonProfileConfirmationBanner;
